import { Component, Input, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MascotasComponent } from '../mascotas.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalConstants } from '../../global-constants';
import { QueryService } from '../../comun/services/query.service';
import { FuncionesService } from '../../comun/services/funciones.service';
import { forkJoin, from } from 'rxjs';
import { concatMap, toArray } from 'rxjs/operators';
import { LoaderService } from '../../comun/services/loader.service';
import { ImagePopupService } from '../../comun/services/image-popup.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { PerfilStatusService } from '../../comun/services/perfil-status.service';

@Component({
  selector: 'app-mascota-show',
  templateUrl: './mascota-show.component.html',
  styleUrls: ['./mascota-show.component.css']
})
export class MascotaShowComponent implements OnChanges {
  @Input() mascota: any = {};
  @Input() ancho: any = {};
  @ViewChild('fileInputFotosMascota') fileInput!: ElementRef<HTMLInputElement>;
  visible: boolean = false;
  fotoSeleccionada: string = "";
  error: string = '';
  personalidadesSeleccionadas: any[] = [];
  personalidades: any[] = [];
  tipos_mascotas: any[] = [];
  nivelesEnergia: any[] = [
    { value: 1, label: 'Bajo' },
    { value: 2, label: 'Medio' },
    { value: 3, label: 'Alto' },
    { value: 4, label: 'Muy alto' }
  ];

  constructor(public app: MascotasComponent,
              private query: QueryService,
              public funciones: FuncionesService,
              private http: HttpClient,
              public loader: LoaderService,
              public imagepopup: ImagePopupService,
              private toastr: ToastrService,
              private perfilStatus: PerfilStatusService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mascota'] && this.mascota?.ma_id) {
      this.fotosMascota();
      this.sincronizarSeleccionadas();
    }
    if (this.mascota.edit && this.tipos_mascotas.length == 0)
      this.getTiposMascotas();
  }

  ngAfterViewInit() {
    this.app.imagepopup.init();
  }

  /*getCarouselImages(fotos: any): { thumb: string; full: string }[] {
    // Caso base: si no hay comentario, rs_fotos no existe o está vacío
    if (!fotos?.length) {
      return [];
    }

    return fotos.map((foto: any) => ({
      thumb: foto.foto_thumb || '',   // miniatura
      full: foto.foto_grande || ''    // imagen grande usada en el carousel
    }));
  }*/

  seleccionarFoto(foto: any) {
    if (!this.mascota.edit) {
      this.mascota.foto = this.mascota.foto || {};
      this.mascota.foto.foto_thumb = foto.data || foto.url;//foto.foto_thumb; 
      this.mascota.foto.foto_grande = foto.data || foto.url; //foto.foto_grande;
      this.fotoSeleccionada = foto.data || foto.url || '';
    } else {
      this.onClickImagen();
    }
  }

  /** Reordena las miniaturas de la ficha en modo edición y conserva
   * sincronizados los originales usados por ORDEN_FOTOS. */
  soltarMiniatura(event: CdkDragDrop<any[]>): void {
    if (!this.mascota?.edit || event.previousIndex === event.currentIndex) return;
    const previas = this.mascota.previewUrl;
    const originales = this.mascota.imagenes;
    if (!Array.isArray(previas) || !Array.isArray(originales) || previas.length !== originales.length) return;
    moveItemInArray(previas, event.previousIndex, event.currentIndex);
    moveItemInArray(originales, event.previousIndex, event.currentIndex);
  }

  fotosActivas(): any[] {
    return (this.mascota?.imagenes || []).filter((foto: any) => !foto.borrada && (foto.data || foto.url));
  }

  moverFoto(direccion: number): void {
    const fotos = this.fotosActivas();
    if (fotos.length < 2) return;
    const actual = fotos.findIndex((foto: any) => (foto.data || foto.url) === this.fotoSeleccionada);
    const siguiente = ((actual < 0 ? 0 : actual) + direccion + fotos.length) % fotos.length;
    this.seleccionarFoto(fotos[siguiente]);
  }

  getTiposMascotas() {
    this.query.query('mascotas', 'TIPOS', null).subscribe((resultado:any) => {
      this.tipos_mascotas = resultado.registros;
    });
  }

  editarMascota(mascota: any) {
    if (this.mascota.edit) {
      this.guardarMascota(true);
    } else {
      this.getTiposMascotas();
      this.getPersonalidades();
      this.sincronizarSeleccionadas();
      this.mascota.edit = true;
    }
  }

  cancelarMascota(mascota: any) {
    this.getMascota();
  }

  personalidadesAtributos() {
    this.mascota.atributos = [];
    for (const perso of this.personalidadesSeleccionadas) {
      this.mascota.atributos.push({
        at_id: 0,
        at_ma_id: this.mascota.ma_id,
        at_atributo: perso.va_nombre
      });
    }
  }

  getPersonalidades() {
    this.query.query('valores', 'GET', { grupo: 'PERSONALIDAD'}).subscribe((resultado:any) => {
      this.personalidades = resultado.registros;
      this.sincronizarSeleccionadas();
    });
  }

  sincronizarSeleccionadas(): void {
    if (!Array.isArray(this.personalidades) || !Array.isArray(this.mascota?.atributos)) return;
    const elegidos = new Set(this.mascota.atributos.map((a: any) =>
      String(a.at_atributo || '').trim().toLocaleLowerCase()));
    this.personalidadesSeleccionadas = this.personalidades.filter((p: any) =>
      elegidos.has(String(p.va_nombre || '').trim().toLocaleLowerCase()));
  }

  onCheckChange(personalidad: any) {
    if (!this.personalidadesSeleccionadas.some((p: any) => p.va_nombre === personalidad.va_nombre)) {
      this.personalidadesSeleccionadas.push(personalidad);
    } else {
      this.personalidadesSeleccionadas = this.personalidadesSeleccionadas.filter(
        p => p.va_nombre !== personalidad.va_nombre
      );
    }
    //this.guardarMascota(false);
  }

  /** Persistir orden y foto principal después de subir/borrar archivos. */
  private sincronizarOrdenFotos(mascotaId: number, terminado: () => void, fallo: () => void): void {
    const ordenLocal = (this.mascota.imagenes || []).filter((f: any) => !f.borrada);
    this.query.query('mascotas', 'GET', { ID: this.mascota.ma_us_id, ma_id: mascotaId }).subscribe({
      next: (respuesta: any) => {
        const fotosBD: any[] = respuesta?.registros?.[0]?.fotos || [];
        const existentes = new Set(ordenLocal.filter((f: any) => Number(f.ft_id) > 0).map((f: any) => Number(f.ft_id)));
        const nuevos = fotosBD.filter((f: any) => !existentes.has(Number(f.ft_id)))
          .sort((a: any,b: any) => Number(a.ft_id) - Number(b.ft_id));
        const pendientes = [...nuevos];
        const ids = ordenLocal.map((f: any) => Number(f.ft_id) || Number(pendientes.shift()?.ft_id || 0))
          .filter((id: number) => id > 0);
        if (ids.length !== fotosBD.length || new Set(ids).size !== ids.length) { fallo(); return; }
        this.query.query('mascotas', 'ORDEN_FOTOS', { ma_id: mascotaId, fotos: ids }).subscribe({
          next: (res: any) => res?.resultado === 'OK' ? terminado() : fallo(), error: fallo
        });
      }, error: fallo
    });
  }

  guardarMascota(loading: boolean = true) {
    if (loading) this.loader.show();
    this.error = '';
    //this.app.subirScroll();
    this.personalidadesAtributos();
    this.mascota.ma_megusta = (this.mascota.ma_megusta || '').slice(0, 500);
    this.query.query('mascotas', 'SAVE', this.mascota).subscribe((resultado:any) => {
      if (resultado?.resultado !== 'OK') { if (loading) this.loader.hide(); this.toastr.error(resultado?.mensaje || 'No se pudo guardar'); return; }
      const llamadas: any[] = [];
      if (this.mascota.data != null && this.mascota.data != '') {
        const formData = new FormData();
        formData.append('data', this.mascota.data);
        formData.append('principal', 'X');
        formData.append('tipo', 'MA');
        formData.append('tipo_id', resultado.id);
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        llamadas.push(this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers }));
      }
      if (this.mascota.imagenes && this.mascota.imagenes.length > 0) {
        for (const img of this.mascota.imagenes) {
          // Nueva a subir
          if (img.url == '' && !img.borrada) {
            const formData = new FormData();
            formData.append('data', img.data);
            // si es la primera es la principal
            //if (esPrimero) {
            //  formData.append('principal', 'X');
            //  esPrimero = false;
            //} else {
              formData.append('principal', '');
            //}
            formData.append('tipo', 'MA');
            formData.append('tipo_id', resultado.id);
            const token = localStorage.getItem('token');
            const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
            llamadas.push(this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers }));
          // Borrar foto
          } else if (img.borrada && img.url != '') {
            llamadas.push(this.query.query('misdatos', 'DELETE_FOTO', { ft_id: img.ft_id }));
          }
        }
      }
      // Convertir array → objeto para evitar deprecación
      const llamadasObj = llamadas.reduce((acc, obs, i) => {
        acc[i] = obs;
        return acc;
      }, {} as { [key: string]: any });

      const finalizar = () => {
        this.mascota.edit = false;
        this.getMascota();
        this.app.getMascotas();
        this.perfilStatus.notificarCambioLocal();
        if (loading) this.loader.hide();
      };
      const errorFotos = () => {if (loading) this.loader.hide(); this.toastr.error('No se pudieron guardar las fotos o su orden');};
      const sincronizar = () => this.sincronizarOrdenFotos(Number(resultado.id), finalizar, errorFotos);
      if (llamadas.length > 0) {
        from(llamadas).pipe(concatMap((peticion: any) => peticion), toArray()).subscribe({next: sincronizar, error: errorFotos});
      } else { sincronizar(); }
    }, () => { if (loading) this.loader.hide(); this.toastr.error('Error al guardar la mascota'); });
  }

  getMascota() {
    this.query.query('mascotas', 'GET', { ID: this.mascota.ma_us_id, ma_id: this.mascota.ma_id }).subscribe((resultado:any) => {
      this.mascota = resultado.registros[0];
      this.sincronizarSeleccionadas();
      this.fotosMascota();
    });
  }

  numeroFotosActivas(): number {
    if (!this.mascota.imagenes || this.mascota.imagenes.length == 0) {
      return 0;
    }
    return this.mascota.imagenes.filter((img: any) => img.borrada !== true).length;
  }

  onClickImagen() {
    // Simula el click en el input file
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const LIMITE_MAXIMO = 6;

      // 1. Contar SOLO las fotos que NO están borradas
      const fotosActivas = Number(this.numeroFotosActivas());

      // 2. Validar si ya llegó al límite de activas
      if (fotosActivas >= LIMITE_MAXIMO) {
        this.toastr.error(`Ya has alcanzado el límite máximo de ${LIMITE_MAXIMO} fotos activas.`);
        input.value = '';
        return;
      }

      // 3. Calcular cuántas fotos nuevas se permiten
      const fotosPermitidas = LIMITE_MAXIMO - fotosActivas;
      const archivosAProcesar = Array.from(input.files).slice(0, fotosPermitidas);

      if (input.files.length > fotosPermitidas) {
        this.toastr.warning(`Solo se agregaron las primeras ${fotosPermitidas} fotos. El límite de fotos activas es de ${LIMITE_MAXIMO}.`);
      }

      // 4. El punto de inicio para AGREGAR al final del array sigue siendo el length total
      // (así las nuevas se posicionan después de las borradas existentes sin machacarlas)
      const startIndex = this.mascota.imagenes.length;

      archivosAProcesar.forEach((file: File, i: number) => {
        const index = startIndex + i;

        // Reservar posición
        this.mascota.imagenes[index] = { data: '', url: '', borrada: false, ft_id: 0 };
        this.mascota.previewUrl[index] = { data: '', url: '', borrada: false, ft_id: 0 };

        // Imagen original
        const readerOriginal = new FileReader();
        readerOriginal.onload = () => {
          this.mascota.imagenes[index].data = readerOriginal.result;
        };
        readerOriginal.readAsDataURL(file);

        // Preview recortado
        this.funciones.recortarImagenCuadrada(file, 500)
          .then((dataUrl) => {
            this.mascota.previewUrl[index].data = dataUrl;
          })
          .catch(console.error);
      });

      input.value = ''; 
    }
  }

  fotosMascota() {
    this.mascota.imagenes = [];
    this.mascota.previewUrl = [];
    this.fotoSeleccionada = this.mascota?.foto?.foto_grande || '';
    if (!this.mascota.fotos) 
      return;
    ([...this.mascota.fotos].sort((a: any, b: any) => (Number(a.ft_orden ?? 9999) - Number(b.ft_orden ?? 9999)) || (a.ft_principal === "X" ? -1 : 0) - (b.ft_principal === "X" ? -1 : 0))).forEach((foto: { foto_thumb: string, foto_grande: string, ft_id: number, ft_principal: string }) => {
      //if (foto.ft_principal == '') {
        this.mascota.imagenes.push({
          data: '',
          url: foto.foto_grande,
          borrada: false,
          ft_id: foto.ft_id
        });

        this.mascota.previewUrl.push({
          data: '',
          url: foto.foto_thumb,
          borrada: false,
          ft_id: foto.ft_id
        });
      //}
    });
  }

  borrarFoto(indexABorrar: number, temporal: boolean = false) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar esta foto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.mascota.imagenes[indexABorrar].borrada = true;
        this.mascota.previewUrl[indexABorrar].borrada = true;
        /*this.mascota.imagenes = this.mascota.imagenes.filter(
          (_: any, index: number) => index !== indexABorrar
        );
        this.mascota.previewUrl = this.mascota.previewUrl.filter(
          (_: any, index: number) => index !== indexABorrar
        );*/
      } else {
      }
    });
  }

  calcularEdad() {
    this.mascota.ma_edad = this.funciones.calcularEdad(this.mascota.ma_fecha_nac);
  }

  queEnergia(mascota: any) {
    this.query.query('valores', 'GET', { grupo: 'ENERGIA' }).subscribe((resultado: any) => {
      // Buscamos el elemento cuyo va_id coincida con el id seleccionado en el modelo
      const energiaEncontrada = resultado.registros.find(
        (item: any) => item.va_id === mascota.ma_energia
      );
      // Si lo encuentra, asignamos el nombre. Si no, dejamos un guion.
      if (energiaEncontrada) {
        mascota.ma_energia_nombre = energiaEncontrada.va_nombre;
      } else {
        mascota.ma_energia_nombre = '-';
      }
    });
  }

}
